import { useRef, useEffect } from 'react';

/**
 * Scroll to bottom when user sends a message
 */
export const useAutoScroll = (messages, isLoading) => {
  const messagesEndRef = useRef(null);
  const prevMessageCountRef = useRef(messages.length);
  
  useEffect(() => {
    if (messages.length > prevMessageCountRef.current) {
      const lastMessage = messages[messages.length - 1];
      const isUserMessage = lastMessage?.sender === 'user' || lastMessage?.type === 'USER';
      
      if (isUserMessage && messagesEndRef.current) {
        // SCROLL TO THE FUCKING BOTTOM
        setTimeout(() => {
          messagesEndRef.current?.scrollIntoView({ 
            behavior: 'smooth',
            block: 'end'
          });
        }, 50);
      }
    }
    
    prevMessageCountRef.current = messages.length;
  }, [messages]);
  
  return messagesEndRef;
};
